module.exports = __webpack_public_path__ + "static/img/调查问卷.5c14773.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/调查问卷.png
// module id = wXb4
// module chunks = 1